import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';

const LanguageToggle = () => {
  const { i18n } = useTranslation();
  const toggle = () => i18n.changeLanguage(i18n.language === 'en' ? 'gr' : 'en');

  return (
    <button onClick={toggle}
      className="inline-flex items-center gap-1.5 px-3 py-1.5 text-[12px] font-medium rounded-full text-muted-foreground hover:text-foreground border border-border hover:border-primary/30 transition-colors"
    >
      <Globe className="h-3 w-3" />
      {i18n.language === 'en' ? 'ΕΛ' : 'EN'}
    </button>
  );
};

export default LanguageToggle;
